module.exports = __webpack_public_path__ + "img/lc.d71a02c5.svg";